import { ONETRUST } from '@app/constants/commonConstants';
import { getCookie } from '@app/utils';

// Replace preview image of a video with it's iframe.
const loadYoutubeVideoOnClick = (id, w, h) => {
  const code = `<iframe src="https://www.youtube.com/embed/${id}/?autoplay=1&loop=1&playlist=${id}&rel=0&autohide=1&border=0&wmode=opaque&enablejsapi=1" class="d-block" width="${w}" height="${h}" frameborder=0 allowfullscreen="" scrolling="no" allow="autoplay; encrypted-media" style="border:1px solid #ccc;" loading="lazy"></iframe>`;

  let iframe = document.createElement('div');
  iframe.innerHTML = code;
  iframe = iframe.firstChild;
  const div = document.getElementById(`cat-youtubevid-${id}`);
  div.parentNode.replaceChild(iframe, div);
};
export const isCookiesEnable = () => {
  let cookieValue = getCookie('OptanonConsent');
  if (cookieValue?.includes(ONETRUST.TARGET_COOKIES_ACCEPTED)) {
    oneTrustScriptToInject();
  }
};
export const optimizeYouTubeIframeEmbeds = () => {
  // Get all iframes
  const frames = document.getElementsByTagName('iframe');

  // Loop through each iframe in the page.
  for (let i = 0; i < frames.length; i++) {
    // Find out youtube embed iframes.
    if (
      frames[i].src &&
      frames[i].src.length > 0 &&
      frames[i].src.match(/http(s)?:\/\/www\.youtube\.com/)
    ) {
      // For Youtube iframe, extract src and id.
      const src = frames[i].src;
      const p =
        /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      let id = src.match(p) ? RegExp.$1 : false;
      if (id === false) {
        continue;
      }

      // Get width and height.
      let w = frames[i].width;
      const h = frames[i].height;
      if (src === '' || w === '' || h === '') {
        continue;
      }

      // The image+button overlay code.
      const code = `<div class="ytvideo position-relative video-thumbnails-container" style="height: ${h}px; display:none" alt="" id="cat-youtubevid-${id}"><div class="ytvideo__gradient w-100 position-absolute pb-5" data-layer="1"></div><div class="ytvideo__top position-absolute pt-1 d-flex flex-nowrap justify-content-end"><div class="ytvideo__logo position-absolute float-start"><svg  class="d-block" version="1.0" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"><path id="path2386" d="M34.5,61.8c1.7-1.6,2-3.5,2-5.2v-7.3h-9.2v9.9c0,1.4-1,2.6-2.3,2.6s-2.2-1.1-2.2-2.6V31.1c0-1.4,0.9-2.6,2.2-2.6s2.3,1.1,2.3,2.6v10h9.1V30.7c0-5.7-3.4-10.4-11.5-10.4c-8.4,0-11.6,4.7-11.6,10.4V60c0,5.7,4,10,9.2,10h2.8L34.5,61.8z"/><polygon points="70.6,63 70.6,30.8 64.3,30.8 64.3,21.3 87.2,21.3 87.2,30.8 80.8,30.8 80.8,70 78.1,70 "/><polygon fill="#FEC40E" points="74.7,70 52.4,49.2 29.4,70 "/><path d="M50,43.6l2.5-14l2.5,14H50z M58.8,21.3H46l-7.4,37.1L52.4,46l14.4,13.5L58.8,21.3z"/><g><path d="M93.3,21.2c1.6,0,2.9,1.3,2.9,2.9S94.9,27,93.3,27s-2.9-1.3-2.9-2.9S91.7,21.2,93.3,21.2z M93.3,21.6c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5C95.8,22.6,94.7,21.6,93.3,21.6z M93.3,24.3h-0.7v1.5h-0.4v-3.4h1.3c0.8,0,1.2,0.3,1.2,1c0,0.6-0.4,0.9-0.9,1l1,1.5h-0.5L93.3,24.3z M93.4,23.9c0.6,0,0.9-0.1,0.9-0.6s-0.3-0.6-0.8-0.6h-0.9v1.2H93.4z"/></g></svg></div><div id="${id}_title" class="ytvideo__title w-100 ps-5 pt-2 overflow-hidden"></div></div><div class="ytvideo__player"><div class="ytvideo__img position-absolute " style="background-image:url(\'https://i.ytimg.com/vi/${id}/hqdefault.jpg\');"></div><div class="ytvideo__button position-absolute p-0 " style=""><svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path class="ytvideo__svg position-absolute w-100" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#212121" fill-opacity="0.8"></path><path d="M 45,24 27,14 27,34" fill="#fff"></path></svg></div></div></div>`;

      // Replace the iframe with a the image+button code.
      let div = document.createElement('div');
      div.innerHTML = code;
      div = div.firstChild;
      frames[i].parentNode.replaceChild(div, frames[i]);
      i--;

      //Save video titles
      if (id) {
        const ytvideo = document.getElementById('cat-youtubevid-' + id);
        if (ytvideo) {
          ytvideo.addEventListener('click', () => {
            loadYoutubeVideoOnClick(id, w, h);
          });
          const parent1 = ytvideo.parentElement;
          if (parent1) {
            const parent2 = parent1.parentElement;
            if (parent2) {
              const titleArray = document.getElementsByTagName('h3', parent2);
              if (
                titleArray !== null &&
                titleArray !== undefined &&
                titleArray.length > 0 &&
                document.getElementById(id + '_title')
              ) {
                document.getElementById(id + '_title').innerHTML =
                  titleArray[0].innerHTML;
              }
            }
          }
        }
      }
    }
  }
};
export const oneTrustScriptToInject = () => {
  let warningComponent = document.getElementsByClassName(
    'video-cookie-warning'
  );
  let videoThumbnails = document.getElementsByClassName(
    'video-thumbnails-container'
  );
  if (videoThumbnails.length > 0) {
    for (let i = 0; i < videoThumbnails.length; i++) {
      warningComponent[i].style.display = 'none';
      videoThumbnails[i].style.display = 'block';
    }
  }
};

export const replaceIframeWithWarning = () => {
  let frames = document.getElementsByTagName('iframe');
  let embeds = document.getElementsByTagName('embed');
  let videos = [...frames, ...embeds];
  let cookiewarningElement = document.getElementById('video-cookie-warning');
  let warningHTML = cookiewarningElement.outerHTML;
  for (const element of videos) {
    if (
      element.src &&
      element.src.length > 0 &&
      element.src.match(/http(s)?:\/\/www\.youtube\.com/)
    ) {
      let data = element.nodeName == 'EMBED' ? element.parentNode : element;

      data.classList.add('video-thumbnails-container');
      data.style.float = 'inline-end';
      cookiewarningElement.remove();
      let div = document.createElement('div');
      div.innerHTML = warningHTML;
      div = div.firstChild;
      div.classList.remove('d-none');
      data.parentNode.insertBefore(div, data);
      data.style.display = 'none';
    }
  }
};

const getCollapsedState = ele => {
  if (ele.currentTarget) {
    return ele.currentTarget.getAttribute('aria-expanded') !== 'true';
  }
  return false;
};

const collapseSection = ele => {
  if (ele) {
    ele
      .querySelector('.accordion__toggle')
      .setAttribute('aria-expanded', 'false');
    if (ele.querySelector('.accordion__item-content').getAttribute('role')) {
      ele.querySelector('.accordion__item-content').style.maxHeight = null;
    }
  }
};

const expandSection = ele => {
  if (
    ele.currentTarget &&
    ele.currentTarget.nextElementSibling.getAttribute('role')
  ) {
    const element = ele.currentTarget.nextElementSibling;

    const sectionHeight = element.scrollHeight;

    element.style.maxHeight = sectionHeight + 'px';
    ele.currentTarget.setAttribute('aria-expanded', 'true');
  }
};

const handleToggleClick = e => {
  const isCollapsed = getCollapsedState(e);

  e.currentTarget.parentElement.parentElement
    .querySelectorAll('.accordion__item')
    .forEach(collapseSection);
  if (isCollapsed) {
    expandSection(e);
  }
};

export const loadAccordion = () => {
  document.querySelectorAll('.accordion__toggle').forEach(toggleBtn => {
    toggleBtn.addEventListener('click', handleToggleClick);
  });

  document.querySelectorAll('.accordion__item').forEach(section => {
    if (!getCollapsedState(section)) {
      expandSection(section);
    }
  });
};

export default { loadAccordion, optimizeYouTubeIframeEmbeds };
